import React, { ReactElement } from 'react'
import { Text } from '@mindfulchefuk/design-system'
import {
  DeliveryRecipe,
  RecipeWithQuantity,
} from '@mindfulchefuk/features/Recipes/interfaces'
import { RecipeModalAccordions } from '@mindfulchefuk/features//Recipes/components/RecipeModal/RecipeModalAccordions'
import { RecipeModalBanner } from '@mindfulchefuk/features//Recipes/components/RecipeModal/RecipeModalBanner'
import { RecipeModalQuantitySelector } from '@mindfulchefuk/features/Recipes/components/RecipeModal/RecipeModalQuantitySelector/RecipeModalQuantitySelector'
import { RecipeModalScrollArea } from '@mindfulchefuk/features/Recipes/components/RecipeModal/RecipeModalScrollArea'
import { RecipeModalTitleWithSpicinessLevel } from '@mindfulchefuk/features/Recipes/components/RecipeModal/RecipeModalRightSide/RecipeModalTitleWithSpicinessLevel'
import { RecipeModalStatsGroup } from './RecipeModalStatsGroup/RecipeModalStatsGroup'

export type TRecipeModalRightSide = {
  isAdditionDisabled: boolean
  isWithinOrderWindow?: boolean
  onDecrement?: (recipe: RecipeWithQuantity) => void
  onIncrement?: (
    recipe: RecipeWithQuantity,
    isRecipeRecommended: boolean
  ) => void
  recipe: RecipeWithQuantity | DeliveryRecipe
  withCookingInstructions?: boolean
}
export const RecipeModalRightSide = ({
  isAdditionDisabled = false,
  isWithinOrderWindow = true,
  onDecrement,
  onIncrement,
  recipe,
  withCookingInstructions,
}: TRecipeModalRightSide): ReactElement => {
  const {
    carbonRating,
    description,
    feedback,
    cookingTime,
    prepTime,
    spicinessLevel,
    price,
    pricePerPerson,
    cookingInstructions,
    title,
    id,
  } = recipe

  const showInstructions =
    withCookingInstructions && !!cookingInstructions.length
  const shouldActionButtonsDisplay = Boolean(
    onDecrement && onIncrement && isWithinOrderWindow
  )

  return (
    <RecipeModalScrollArea>
      <RecipeModalTitleWithSpicinessLevel
        title={title}
        spicinessLevel={spicinessLevel}
      />
      <Text color="pepper" variant="body-md-500" as="p" mb={24}>
        {description}
      </Text>

      <RecipeModalStatsGroup
        carbonRatingLow={carbonRating === 'Low'}
        cookingTime={cookingTime}
        feedback={feedback}
        prepTime={prepTime}
        price={price}
        pricePerPerson={pricePerPerson}
        productId={id}
        productName={title}
      />

      <RecipeModalBanner recipeId={recipe.id} />

      {shouldActionButtonsDisplay && (
        <RecipeModalQuantitySelector
          isAdditionDisabled={isAdditionDisabled}
          onDecrement={onDecrement}
          onIncrement={onIncrement}
          recipe={recipe}
        />
      )}

      <RecipeModalAccordions
        showInstructions={showInstructions}
        recipe={recipe}
      />
    </RecipeModalScrollArea>
  )
}
